import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';

import Setup from './../components/Setup';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    softwares: state.softwares,
    dashboard: state.dashboard,
    carriers: state.carriers,
    business: state.business,
    auth: state.auth,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Setup);
